import { useEffect } from 'react'
import { useAppDispatch } from '@/redux/hooks/useAppDispatch'
import { LOGOUT } from '../../../app/authState'
import { dateHelper } from '../../../utils/dateUtils'
import { AUTH_VALIDATE_ROUTE } from '../../../utils/constants'

const TIMEOUT_LENGTH = 1800000
// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const AppLogout = ({ children }) => {
  const dispatch = useAppDispatch()
  const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress', 'keyup', 'keydown']
  // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
  let timer

  const resetTimer = () => {
    // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
    if (timer) clearTimeout(timer)
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const handleLogoutTimer = (length) => {
    const logoutAction = () => {
      if (
        !(window.location.pathname === '/') &&
        !(window.location.pathname === '/forgot-password') &&
        !(window.location.pathname === '/resetPassword') &&
        !(window.location.pathname === '/verifyEmail') &&
        !(window.location.pathname === AUTH_VALIDATE_ROUTE)
      ) {
        // Dispatching is what makes this a real logout. It used to clear `localStorage`
        // and navigate without ever telling redux, so the reducers still held the patient
        // list and the persistoid — never paused — wrote it back into the storage that had
        // just been emptied. `logoutTeardownMiddleware` now does the clearing, the Segment
        // reset, the key shred and the navigation. See QMD-4332.
        dispatch({ type: LOGOUT, reason: 'inactivity-timeout' })
      }
    }
    timer = setTimeout(() => {
      resetTimer()
      // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
      const logoutTime = JSON.parse(localStorage.getItem('lastUserAction')) + TIMEOUT_LENGTH

      if (logoutTime <= dateHelper.getTimeInMilliseconds()) {
        Object.values(events).forEach((item) => {
          window.removeEventListener(item, resetTimer)
        })
        logoutAction()
      } else {
        handleLogoutTimer(logoutTime - dateHelper.getTimeInMilliseconds())
      }
    }, length || TIMEOUT_LENGTH)
  }
  const checkerCallback = () => {
    if (localStorage.getItem('lastUserAction')) {
      localStorage.removeItem('lastUserAction')
      localStorage.setItem('lastUserAction', JSON.stringify(dateHelper.getTimeInMilliseconds()))
    } else {
      localStorage.setItem('lastUserAction', JSON.stringify(dateHelper.getTimeInMilliseconds()))
    }
    resetTimer()
    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
    handleLogoutTimer()
  }

  useEffect(() => {
    Object.values(events).forEach((item) => {
      window.addEventListener(item, checkerCallback, true)
    })

    return () =>
      Object.values(events).forEach((item) => {
        window.removeEventListener(item, checkerCallback, true)
      })
  }, [])

  return children
}
